export default __webpack_public_path__ + "static/media/youtube.ceeaa863.svg";